module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAAABHNCSVQICAgIfAhkiAAAAQtJREFUOE+lkmFRw0AUhL91gAMqARRQHIACqIIWBzigEooCwAESQAE4aFGwzIZLJhwh06b3J5O5977bt2/Fnsf2M7CVtPivRXuysP0KXAD5Xkva1b1TYGG8AZc1cCoswCgLMODmDMJsnwA3wBUwH7EiwIyc0f/CbK+Ah329LHULSZtfymxviqIDWU35eQezvQaWUyjAI7BqYLZnwMdUkKTbzrOB8d5LnvpZSsNp9eCdpEz0s82yuW35f2nkSp+1yl5o26vG9H5dYFn/U+Zu5Q6N24N9JTJtHGpYZM4lnY15VmCpSW0X1BqWwN0PvdQvtB3QbsiCvmdrSQnq0SeexfBuI8cQA5uNST8E/g0WgW1Madad/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/redoIcon.png
// module id = p2gL
// module chunks = 3